import React from "react";
import houseOfStoxLogo from "./assets/HOUSEOFSTOX.webp";
import "./loadingScreen.css";

const AppLoadingScreen = () => (
  <div className="app-boot-overlay">
    <div className="app-boot-card">
      <img
        src={houseOfStoxLogo}
        alt="House of Stox"
        className="app-boot-logo"
      />
      <div className="app-boot-progress">
        <div className="app-boot-progress-fill" />
      </div>
      <div className="app-boot-text">
        <span>Loading application</span>
        <span className="app-boot-dots">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </div>
    </div>
  </div>
);

export default AppLoadingScreen;
